export default "__VITE_ASSET__Xyzot8rt__"